import { Controller } from "@hotwired/stimulus"

/**
 * FileInputController - Maneja la selección de archivos y actualiza la UI
 * Conecta a data-controller="file-input"
 */
export default class extends Controller {
  static targets = ["filename", "submit"]

  handleFileSelect(event) {
    const file = event.target.files?.[0]
    
    if (file) {
      this.#showFileSelected(file.name)
    } else {
      this.#hideFileSelected()
    }
  }

  #showFileSelected(filename) {
    this.filenameTarget.textContent = filename
    this.submitTarget.classList.remove('d-none')
  }

  #hideFileSelected() {
    this.filenameTarget.textContent = ""
    this.submitTarget.classList.add('d-none')
  }
}
